// Sim Racing Expo Frankfurt 2026: 15% off everything, for every visitor.
//
// The discount itself is a normal multi-use backend coupon (one % on the whole
// basket, applied at checkout). The website only:
//  - applies the code automatically for every visitor while the promo runs
//    (sessionStore.hydrateFromLocalStorage + the checkout seed), and
//  - shows the top bar with a countdown (AnnouncementBar).
// Window: 15 Oct 00:00 to 19 Oct 23:59 Los Angeles time (PDT), so it is on
// when the US wakes up on the 15th (Frankfurt 09:00, Sydney 18:00 that day).
// Nothing shows before `start`. The backend coupon expires by itself at `end`.

export const EXPO_PROMO = {
  code: 'simexpo2026frankfurt',
  percent: 15,
  start: '2026-10-15T07:00:00Z',
  end: '2026-10-20T07:00:00Z',
  // pill on every buyable shop card while the promo runs (ShopItem)
  cardTag: 'Sim Expo 2026 - 15% discount applied on checkout',
  // uDFP20 torque upgrades are excluded from the promo (backend:
  // ChargedOrderInfo.isExcludedFromPercentOffRegularPrice); their card says so.
  excludedCardTag: 'Torque upgrades are excluded from the Sim Expo sale',
}

const ms = (iso) => Date.parse(iso)

/** True while the promo runs. */
export function isExpoPromoLive(nowMs = Date.now()) {
  return nowMs >= ms(EXPO_PROMO.start) && nowMs < ms(EXPO_PROMO.end)
}

/** The code to apply automatically right now, or null. */
export function getAutoDiscountCode(nowMs = Date.now()) {
  return isExpoPromoLive(nowMs) ? EXPO_PROMO.code : null
}

export const expoPromoEndMs = () => ms(EXPO_PROMO.end)

/** uDFP20 torque upgrade item types (UDFP20_<from>_TO_<to>_UPGRADE) never get the promo. */
export const isExcludedFromExpoPromo = (itemType) => /^UDFP20_\d+_TO_\d+_UPGRADE$/.test(String(itemType || ''))
